<template>
    <!-- 订单-订单模式-添加/编辑 -->
    <!-- 普通模式：可同时存在多个，但仅限一个开启。（客户下单，司机创单普通模式） 端口：全部，客户，司机
              创单模式：可同时存在多个，但仅限一个开启。（司机创单公里模式）端口：司机
              合作模式：商家合作模式，可同时存在多个，开启多个。可设置密码 端口：全部，客户，司机
              三方模式：三方合作模式，可同时存在多个，开启多个。端口：三方 -->
    <el-drawer
        title="修改模式类型"
        :visible.sync="show"
        :before-close="closeDialog"
        :with-header="false"
        size="1040px"
        class="order-model-wrap"
        :wrapperClosable="false"
    >
        <div class="mode-title-package" v-if="modeName == '包时'">
            <h2>{{ modeName }}模式</h2>
            <div v-if="modeName == '包时'" class="tips">注：包时模式开启，平台抽取订单流水15%</div>
        </div>

        <div class="mode-title" v-else>
            <h2>{{ modeName }}模式</h2>
            <span v-if="modeName == '普通'" style="margin-left: 10px">客户线上下单</span>
        </div>

        <!-- 基本信息表单 -->
        <div class="form-box" v-loading="loading">
            <el-form label-width="110px">
                <div class="btn-plus">
                    <el-button @click="addContent" type="success" style="width: 50px; height: 40px" icon="el-icon-plus"></el-button>
                </div>
                <div class="mode-wrap">
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="模式名称">
                                <el-input v-if="modeName !== '包时'" v-model="submit_data.name" style="width: 150px" :placeholder="submit_rules.name.placeholder">
                                </el-input>
                                <el-select v-model="submit_data.name" filterable placeholder="请选择" v-if="modeName === '包时'" style="width: 150px" :disabled="btnType == 'edit'">
                                    <el-option
                                        v-for="item in modeOptions"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="选择端口">
                                <!-- 下拉选择端口 -->
                                <!-- <el-select v-model="value_port" placeholder="请选择端口" style="width: 150px" @change="portChange" clearable>
                                        <el-option label="司机端" value="driver"> </el-option>
                                        <el-option label="乘客端" value="consumer"> </el-option>
                                        <el-option label="第三方" value="openApi"> </el-option>
                                        <el-option label="全部" value="all"> </el-option>
                                    </el-select> -->
                                <div v-if="modeName == '普通' || modeName == '合作' || modeName == '包时'">
                                    <el-select
                                        v-model="value_port"
                                        placeholder="请选择端口"
                                        style="width: 150px"
                                        @change="portChange"
                                        clearable
                                    >
                                        <el-option label="司机端" value="driver"> </el-option>
                                        <el-option label="乘客端" value="consumer"> </el-option>
                                        <el-option label="全部" value="all"> </el-option>
                                    </el-select>
                                </div>
                                <div v-if="modeName == '创单'">
                                    <el-select
                                        v-model="value_port"
                                        placeholder="请选择端口"
                                        style="width: 150px"
                                        @change="portChange"
                                        clearable
                                    >
                                        <el-option label="司机端" value="driver"> </el-option>
                                    </el-select>
                                </div>

                                <div v-if="modeName == '三方'">
                                    <el-select
                                        v-model="value_port"
                                        placeholder="请选择端口"
                                        style="width: 150px"
                                        @change="portChange"
                                        clearable
                                    >
                                        <el-option label="第三方" value="openApi"> </el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <!-- 不选也是全选，要不然历史订单模式会有问题，所以默认是空，就是对所有司机类型有效 -->

                            <el-form-item label="司机类型">
                                <el-select v-model="sign_type" multiple collapse-tags placeholder="请选择" style="width: 170px">
                                    <el-option label="全职/按月" value="1"></el-option>
                                    <el-option label="兼职/按天" value="0"></el-option>
                                    <el-option label="按单" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="开始拍照">
                                <!-- 是否上传照片(行程开始前) -->
                                <el-select v-model="submit_data.trip_start_upload_status" placeholder="请选择开始拍照" style="width: 150px">
                                    <el-option label="不上传" value="0"> </el-option>
                                    <el-option label="上传允许跳过" value="1"> </el-option>

                                    <el-option label="上传不允许跳过" value="2"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="结束拍照">
                                <!-- 是否上传照片(行程结束) -->
                                <el-select v-model="submit_data.trip_end_upload_status" placeholder="请选择结束拍照" style="width: 150px">
                                    <el-option label="不上传" value="0"> </el-option>
                                    <el-option label="上传允许跳过" value="1"> </el-option>

                                    <el-option label="上传不允许跳过" value="2"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="照片数量">
                                <!-- 上传照片数量限制 -->
                                <el-input v-model="submit_data.restrictive_photo" style="width: 170px" placeholder="数量限制"> </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="导航策略">
                                <el-select v-model="submit_data.strategy" placeholder="请选择导航规划策略" style="width: 150px">
                                    <el-option label="默认" value="default"> </el-option>
                                    <el-option label="距离最短" value="short"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item label="计费时间">
                                <el-select v-model="submit_data.rule_base" placeholder="请选择计费时间" style="width: 150px">
                                    <el-option label="下单时间" value="orderCreate"> </el-option>
                                    <el-option label="开始服务时间" value="orderOnWay"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="选择城市" v-if="btnType == 'edit'">
                                <el-input
                                    placeholder="请输入内容"
                                    v-model="value_city_code"
                                    disabled
                                    style="width: 170px; margin-right: 20px"
                                >
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div style="padding-left: 28px" v-if="modeName !== '包时'">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="扫码指定模式">
                                    <el-switch
                                        v-model="submit_data.scan_appoint_order"
                                        active-text=""
                                        inactive-text=""
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="是否上传车牌号" label-width="136px">
                                    <el-switch v-model="submit_data.send_plate" active-value="1" inactive-value="0"></el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="是否允许相册选择照片" label-width="186px">
                                    <el-switch v-model="submit_data.is_allow_album_photo" active-value="1" inactive-value="0"> </el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="padding-left: 28px" v-if="modeName !== '包时'">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="恶劣天气模式">
                                    <el-switch
                                        v-model="submit_data.is_sleet"
                                        active-value="1"
                                        inactive-value="0"
                                        @change="badweatcherChange"
                                        class="custom-switch"
                                    >
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="是否纯公里模式" label-width="136px">
                                    <el-switch v-model="submit_data.kilometer_mode" active-value="1" inactive-value="0"> </el-switch>
                                </el-form-item>
                            </el-col>
                            <!-- <el-form-item label="模式扣款金额（扣司机余额）" label-width="180px">
                    <div style="display: flex">
                        <el-select @change="selectConfig" v-model="submit_data.kilometer_mode_deduction_type" placeholder="请选择">
                            <el-option label="未使用" value="0"> </el-option>
                            <el-option label="固定金额" value="1"> </el-option>
                            <el-option label="按比例(默认单位%)" value="2"> </el-option>
                        </el-select>
                        <div v-if="submit_data.kilometer_mode_deduction_type != 0">
                            <el-input
                            v-if="submit_data.kilometer_mode_deduction_type == 1"
                            v-model="submit_data.kilometer_mode_deduction"
                            style="width: 150px"
                            placeholder="固定金额"
                        >
                        </el-input>
                        <el-input
                            v-if="submit_data.kilometer_mode_deduction_type == 2"
                            v-model="submit_data.kilometer_mode_deduction"
                            style="width: 150px"
                            placeholder="按比例(默认单位%)"
                        >
                        </el-input>
                        </div>

                        {{
                            submit_data.kilometer_mode_deduction_type == '2'
                                ? '%'
                                : submit_data.kilometer_mode_deduction_type == '1'
                                ? '元'
                                : ''
                        }}
                    </div>
                </el-form-item> -->
                            <el-col :span="8">
                                <el-form-item label="不进司机余额" label-width="130px">
                                    <el-switch v-model="submit_data.not_income_wallet" active-value="1" inactive-value="0"></el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>

                            <el-col :span="8">
                                <el-form-item label="直接进入抢单大厅" label-width="130px">
                                    <el-switch v-model="submit_data.is_not_dispatch" active-value="1" inactive-value="0"></el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="padding-left: 8px" v-if="modeName == '包时'">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="是否允许相册选择照片" label-width="186px">
                                    <el-switch v-model="submit_data.is_allow_album_photo" active-value="1" inactive-value="0"> </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" >
                                <el-form-item label="不进司机余额" label-width="133px">
                                    <el-switch v-model="submit_data.not_income_wallet" active-value="1" inactive-value="0"></el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="直接进入抢单大厅" label-width="166px">
                                    <el-switch v-model="submit_data.is_not_dispatch" active-value="1" inactive-value="0"></el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <div>
                        <el-form-item label="合作模式" v-show="false">
                            <!-- 为了不影响原有功能，开关不显示，但是参数要传 -->
                            <el-switch
                                v-model="submit_data.partner_mode"
                                active-value="1"
                                inactive-value="0"
                                active-text=""
                                inactive-text=""
                            >
                            </el-switch>
                        </el-form-item>
                        <el-form-item label="创单模式" v-show="false">
                            <!-- 为了不影响原有功能，开关不显示，但是参数要传 -->

                            <el-switch v-model="submit_data.wait_mode" active-value="1" inactive-value="0" active-text="" inactive-text="">
                            </el-switch>
                        </el-form-item>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="模式开关" v-if="btnType == 'edit'">
                                    <el-switch
                                        v-model="submit_data.status"
                                        active-value="1"
                                        inactive-value="0"
                                        active-text=""
                                        inactive-text=""
                                        :disabled="openapi==1"
                                    ></el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="是否需要密码" v-show="modeName == '合作'" label-width="138px">
                                    <el-switch
                                        v-model="submit_data.check_password"
                                        active-text=""
                                        inactive-text=""
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="模式密码" v-if="submit_data.check_password == '1'">
                                    <el-input v-model="submit_data.password" style="width: 200px"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <!-- spare_data数据来源于遍历obtain_data对象 把每一个对象添加到spare_data中，obtain_data来自于接口/order/getruleMode -->
                    <div v-for="(item, index) in spare_data" :key="index" class="box-content">
                        <div style="font-size: 16px; font-weight: bold;">配置详情</div>
                        <!-- 删除按钮 -->
                        <div style="display: flex; justify-content: flex-end;">
                            <el-button type="danger" @click="delData(index)" icon="el-icon-close"></el-button>
                        </div>

                        <!-- 选择时间 -->
                        <div>
                            <div class="time-effective common-style">
                                <div style="margin-right: 10px">有效时段</div>
                                <div>
                                    <el-time-picker
                                        style="width: 120px"
                                        v-model="spare_data[index].time_start"
                                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                        placeholder="开始时间"
                                        @change="timeChange($event, 'time_start')"
                                        value-format="HHmm"
                                        format="HH:mm"
                                    >
                                    </el-time-picker>
                                    <el-time-picker
                                        style="width: 120px; margin-left: 10px"
                                        v-model="spare_data[index].time_end"
                                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                                        placeholder="结束时间"
                                        @change="timeChange($event, 'time_end')"
                                        value-format="HHmm"
                                        format="HH:mm"
                                    >
                                    </el-time-picker>
                                </div>
                            </div>

                            <div class="mode-switch common-style" v-if="modeName !== '包时'">
                                <div style="width: 25%">
                                    <!-- 短途特惠 -->
                                    <span style="margin-right: 10px">{{ obtain_data.short_distance_mode.name }}</span>
                                    <el-switch
                                        v-model="spare_data[index].short_distance_mode"
                                        placeholder="请选择"
                                        @change="select(index, 'short_distance')"
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                </div>
                                <div style="width: 25%">
                                    <!-- 一口价 -->
                                    <span style="margin-right: 10px">{{ obtain_data.kilometer_time_mode.name }}</span>
                                    <el-switch
                                        v-model="spare_data[index].kilometer_time_mode"
                                        placeholder="请选择"
                                        @change="select(index, 'kilometer_time_mode')"
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                </div>

                                <div style="width: 25%">
                                    <!-- 双向收费 -->
                                    <span style="margin-right: 10px">{{ obtain_data.two_way_charge.name }}</span>
                                    <el-switch
                                        v-model="spare_data[index].two_way_charge"
                                        placeholder="请选择"
                                        @change="select(index)"
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                    <el-tooltip class="item" effect="dark" content="开启后圈外行驶时长同时计算费用" placement="top">
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </div>
                                <div v-if="submit_data.kilometer_mode == '1'" style="width: 25%">
                                    <!-- 增值公里 是否纯公里模式打开的话，此开关打开 -->
                                    <span style="margin-right: 10px">{{ obtain_data.kilo_step.name }}</span>

                                    <el-switch
                                        v-model="spare_data[index].kilo_step_mode"
                                        placeholder="请选择"
                                        @change="kiloStepChange(index)"
                                        active-value="1"
                                        inactive-value="0"
                                    >
                                    </el-switch>
                                </div>
                            </div>
                        </div>

                        <!-- 一口价开始 -->
                        <div v-if="spare_data[index].kilometer_time_mode == '1'">
                            <p style="text-align: center; color: red">！注意：公里/时间必须从小到大填写</p>

                            <div class="yi-kou-jia-btn">
                                <div>
                                    <el-radio v-model="spare_data[index].kilometer_time_select" label="1">公里一口价</el-radio>
                                    <el-radio v-model="spare_data[index].kilometer_time_select" label="2">时间一口价</el-radio>
                                </div>
                                <div style="display: flex; justify-content: flex-end; margin-bottom: 10px">
                                    <!--    添加按钮      -->
                                    <el-button
                                        @click="addKilo(index)"
                                        type="success"
                                        style="width: 50px; height: 40px"
                                        icon="el-icon-plus"
                                    ></el-button>

                                    <!--     删除按钮     -->
                                    <el-button
                                        @click="subKilo(index)"
                                        type="danger"
                                        style="width: 50px; height: 40px"
                                        icon="el-icon-minus"
                                    ></el-button>
                                </div>
                            </div>

                            <!-- 一口价 -->

                            <div
                                class="mode-short-kilo"
                                v-if="spare_data[index].kilometer_time_select == '1'"
                                v-for="(item2, index2) in spare_data[index].kilo"
                                :key="index2"
                            >
                                <div class="mode-short-kilo-left">
                                    <el-input v-model="item2.kilometer" @input="onInput()"
                                        ><template slot="prepend">公里</template>
                                    </el-input>
                                </div>
                                <div class="new-mode-right" style="width: 70%">
                                    <div class="mode-short-kilo-right">
                                        <el-input v-model="item2.kiloprice" @input="onInput()"
                                            ><template slot="prepend">一口价</template>
                                        </el-input>
                                    </div>
                                    <div style="width: 50%; padding: 20px"></div>
                                </div>
                            </div>

                            <div
                                v-if="spare_data[index].kilometer_time_select == '2'"
                                class="mode-short-kilo"
                                v-for="(item3, index3) in spare_data[index].kilo_time"
                                :key="index3"
                            >
                                <div class="mode-short-kilo-left">
                                    <el-input v-model="item3.kilotime" @input="onInput()"
                                        ><template slot="prepend">分钟</template>
                                    </el-input>
                                </div>
                                <div class="new-mode-right" style="width: 70%">
                                    <div class="mode-short-kilo-right">
                                        <el-input v-model="item3.kilotimeprice" @input="onInput()"
                                            ><template slot="prepend">一口价(元)</template>
                                        </el-input>
                                    </div>
                                    <div style="width: 50%; padding: 20px"></div>
                                </div>
                            </div>
                        </div>
                        <!-- 一口价结束 -->

                        <!--阶梯计费设置 增值公里 如果纯公里模式开关打开并且增值公里模式开关打开 显示下面内容-->
                        <div class="mode-short-kilo" v-if="spare_data[index].kilo_step_mode == '1' && submit_data.kilometer_mode == '1'">
                            <div class="mode-short-kilo-left">
                                <el-input v-model="spare_data[index].kilo_step[0].kilo_step_kilometer" @input="onInput()"
                                    ><template slot="prepend">超出公里数</template>
                                </el-input>
                            </div>
                            <div class="new-mode-right" style="width: 70%">
                                <div class="mode-short-kilo-right">
                                    <el-input v-model="spare_data[index].kilo_step[0].kilo_step_kiloprice" @input="onInput()"
                                        ><template slot="prepend">每公里单价(元)</template>
                                    </el-input>
                                </div>
                                <div style="width: 50%; padding: 20px"></div>
                            </div>
                        </div>

                        <!--恶劣天气开关打开-->
                        <div class="mode-short-kilo" v-if="submit_data.is_sleet == '1'">
                            <div class="mode-short-kilo-left">
                                <el-input v-model="spare_data[index].bad_weather_amount"
                                    ><template slot="prepend">恶劣天气加价(元)</template>
                                </el-input>
                            </div>
                            <div class="new-mode-right" style="width: 70%">
                                <div class="mode-short-kilo-right">
                                    <el-input v-model="spare_data[index].bad_weather_rate"
                                        ><template slot="prepend">恶劣天气加价(%)</template>
                                    </el-input>
                                </div>
                                <div style="width: 50%; padding: 20px"></div>
                            </div>
                        </div>
                        <!-- 点击绿色添加按钮，添加的起步价等模式配置 -->
                        <!-- <div class="mode-config-father">
                        <div
                            style="margin-right: 10px"
                            class="mode-config"
                            v-for="(item2, index2) in obtain_data"
                            :key="index2"
                            v-show="item2.type != 'string' && item2.type != 'select'"
                        >
                            <el-input v-model="spare_data[index][index2]"
                                ><template slot="prepend">{{ item2.name }}</template>
                            </el-input>
                        </div>
                    </div> -->
                        <div style="display: flex" v-if="spare_data[index].short_distance_mode == '1'">
                            <div style="width: 304px; padding: 10px 10px 0 10px">
                                <el-input v-model="spare_data[index].short_starting_price"
                                    ><template slot="prepend">短途起步价</template>
                                </el-input>
                            </div>
                            <div class="new-mode-right" style="width: 70%">
                                <div style="width: 50%; padding: 10px 10px 0 10px">
                                    <el-input v-model="spare_data[index].short_starting_free_kilometre"
                                        ><template slot="prepend">短途起步公里</template>
                                    </el-input>
                                </div>
                                <div style="width: 50%; padding: 10px 10px 0 10px">
                                    <el-input v-model="spare_data[index].short_starting_free_time"
                                        ><template slot="prepend">短途起步时长</template>
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <div class="new-mode-father" v-if="modeName !== '包时'">
                            <!-- 左侧 -->
                            <div class="new-mode-left">
                                <div style="margin-bottom: 10px">
                                    <el-input v-model="spare_data[index].starting_price"
                                        ><template slot="prepend"><span style="color: red">* </span>起步价</template>
                                    </el-input>
                                </div>
                                <div style="margin-bottom: 10px" class="price-top">
                                    <el-input v-model="spare_data[index].circle_top"
                                        ><template slot="prepend">圈内封顶价格</template>
                                    </el-input>
                                    <!-- <el-input v-model="spare_data[index].kilometer_top"
                                        ><template slot="prepend">封顶公里</template>
                                    </el-input> -->
                                </div>
                                <!-- <div style="margin-bottom: 10px">
                                    <el-input v-model="spare_data[index].kilometer_top"
                                        ><template slot="prepend">封顶公里</template>
                                    </el-input>
                                </div> -->
                                <div style="margin-bottom: 10px">
                                    <el-input v-model="spare_data[index].ultra_far_price"
                                        ><template slot="prepend">超远距离附加费</template>
                                    </el-input>
                                </div>
                                <div style="margin-bottom: 10px">
                                    <el-input v-model="spare_data[index].limited_time_offer"
                                        ><template slot="prepend">优惠费用</template>
                                    </el-input>
                                </div>
                            </div>
                            <!-- 右侧 -->
                            <div class="new-mode-right">
                                <!-- 右左 -->
                                <div class="new-mode-right-child">
                                    <div class="new-mode-right-child-left-top">
                                        <div style="margin-bottom: 10px">
                                            <el-input v-model="spare_data[index].starting_free_kilometre"
                                                ><template slot="prepend"><span style="color: red">* </span>起步公里数</template>
                                            </el-input>
                                        </div>
                                        <div>
                                            <el-input v-model="spare_data[index].out_free_kilometre_price"
                                                ><template slot="prepend"><span style="color: red">* </span>里程单价</template>
                                            </el-input>
                                        </div>
                                    </div>
                                    <div class="new-mode-right-child-left-bottom">
                                        <div style="margin-bottom: 10px">
                                            <el-input v-model="spare_data[index].starting_free_waiting"
                                                ><template slot="prepend"><span style="color: red">* </span>免费等待时长</template>
                                            </el-input>
                                        </div>
                                        <div style="margin-bottom: 10px">
                                            <el-input v-model="spare_data[index].out_free_waiting"
                                                ><template slot="prepend"><span style="color: red">* </span>等待超时时长</template>
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                                <!-- 右右 -->
                                <div class="new-mode-right-child">
                                    <div style="border-bottom: 1px solid #ccc; border-left: 1px solid #ccc; padding: 10px 10px 0 10px">
                                        <div style="margin-bottom: 8px">
                                            <el-input v-model="spare_data[index].starting_free_time"
                                                ><template slot="prepend"><span style="color: red">* </span>起步时长</template>
                                            </el-input>
                                        </div>
                                        <div style="margin-bottom: 10px">
                                            <el-input v-model="spare_data[index].out_free_time"
                                                ><template slot="prepend"><span style="color: red">* </span>超出起步时长</template>
                                            </el-input>
                                        </div>
                                        <div style="margin-bottom: 10px">
                                            <el-input v-model="spare_data[index].out_free_time_price"
                                                ><template slot="prepend"><span style="color: red">* </span>超出起步时长单价</template>
                                            </el-input>
                                        </div>
                                    </div>
                                    <div style="margin-top: 10px; padding: 0 10px 10px 10px">
                                        <el-input v-model="spare_data[index].out_free_waiting_price"
                                            ><template slot="prepend"><span style="color: red">* </span>等待超时价格</template>
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="" v-if="modeName == '包时'">
                            <!-- 第一行：起步价、优惠费用 -->
                            <div style="display: flex; width: 100%; padding: 10px 0; border-bottom: 1px solid #eee;border-top: 1px solid #eee;margin-top: 10px;align-items: center;">
                                <!-- <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].starting_price">
                                        <template slot="prepend"><span style="color: red">* </span>起步价</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].limited_time_offer">
                                        <template slot="prepend">优惠费用</template>
                                    </el-input>
                                </div> -->
                                <el-input v-model="spare_data[index].hourly_package_cross_city_price" class="mode-short-kilo-left"
                                    ><template slot="prepend"><span style="color: red">* </span>包时模式跨城费用</template>
                                </el-input>
                                <el-tooltip class="item" effect="dark" content="若起点和终点不在同一城市，则计算此费用" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>

                            <!-- 第二行：起步公里数、里程单价 -->
                            <div style="display: flex; width: 100%; padding: 10px 0; border-bottom: 1px solid #eee;align-items: center;">
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].starting_free_kilometre">
                                        <template slot="prepend"><span style="color: red">* </span>起步公里数</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].out_free_kilometre_price">
                                        <template slot="prepend"><span style="color: red">* </span>里程单价</template>
                                    </el-input>
                                </div>
                                <el-tooltip class="item" effect="dark" content="超出起步公里数的里程，按里程单价计算超远距离附加费用" placement="top">
                                    <i class="el-icon-question"></i>
                                </el-tooltip>
                            </div>

                            <!-- 第三行：起步时长、超出起步时长、超出起步时长单价 -->
                            <div style="display: flex; width: 100%; padding: 10px 0; border-bottom: 1px solid #eee;">
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].starting_free_time">
                                        <template slot="prepend"><span style="color: red">* </span>起步时长</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].out_free_time">
                                        <template slot="prepend"><span style="color: red">* </span>超出起步时长</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].out_free_time_price">
                                        <template slot="prepend"><span style="color: red">* </span>超出起步时长单价</template>
                                    </el-input>
                                </div>
                            </div>

                            <!-- 第四行：免费等待时长、等待超时时长、等待超时价格 -->
                            <div style="display: flex; width: 100%; padding: 10px 0;">
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].starting_free_waiting">
                                        <template slot="prepend"><span style="color: red">* </span>免费等待时长</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].out_free_waiting">
                                        <template slot="prepend"><span style="color: red">* </span>等待超时时长</template>
                                    </el-input>
                                </div>
                                <div class="hour-mode-short-kilo">
                                    <el-input v-model="spare_data[index].out_free_waiting_price">
                                        <template slot="prepend"><span style="color: red">* </span>等待超时价格</template>
                                    </el-input>
                                </div>
                            </div>
                        </div>
                        <!-- 包时模式 -->
                        <div v-if="modeName == '包时'">
                            <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0;">
                                <div style="font-size: 16px; font-weight: bold;">包时配置</div>
                                <div>

                                    <el-button
                                        @click="addHourlyPackage(index)"
                                        type="success"
                                        style="width: 50px; height: 40px"
                                        icon="el-icon-plus"
                                    ></el-button>


                                    <!-- <el-button
                                        @click="subHourlyPackage(index)"
                                        type="danger"
                                        style="width: 50px; height: 40px"
                                        icon="el-icon-minus"
                                    ></el-button> -->
                                </div>
                            </div>
                            <!-- <div style="display: flex; width: 100%; padding: 10px 0; border-bottom: 1px solid #eee;">
                                <el-input v-model="spare_data[index].hourly_package_cross_city_price" class="mode-short-kilo-left"
                                    ><template slot="prepend"><span style="color: red">* </span>包时模式跨城费用</template>
                                </el-input>
                            </div> -->
                            <div
                                class="mode-short-kilo" style="padding-left: 0"
                                v-for="(item4, index4) in spare_data[index].hourly_package_config"
                                :key="index4"
                            >
                                <div class="mode-short-kilo-left">
                                    <el-input v-model="item4.hourly_package_time" @input="onInput()"
                                        ><template slot="prepend"><span style="color: red">* </span>分钟</template>
                                    </el-input>
                                </div>
                                <!-- <div class="mode-short-kilo-right" style="width: 70%">
                                    <el-input v-model="item4.hourly_package_name" @input="onInput()" disabled
                                        ><template slot="prepend">小时</template>
                                    </el-input>
                                </div> -->
                                <div class="mode-short-kilo-left" >
                                    <el-input v-model="item4.hourly_package_price" @input="onInput()"
                                        ><template slot="prepend"><span style="color: red">* </span>价格(元)</template>
                                    </el-input>
                                </div>
                                <div style="padding: 13px 10px 0 0;">
                                    <el-button type="danger" @click="delHourlyPackage(index, index4)" icon="el-icon-close"></el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form>
            <div style="display: flex; justify-content: center">
                <el-button type="primary" @click="drivingModelOnSubmit" style="width: 80px; height: 40px">保存</el-button>
                <el-button @click="closeDialog" style="width: 80px; height: 40px">关闭</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: '', // corder_mode.order_mode_code
        drivingModel_select: Object, // 选择城市下拉选内容
        name: '', // 模式名称
        btnType: '', // 区分添加和编辑
        openapi:''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            // 添加页面
            if (_this.btnType == 'add') {
                _this.loading = false;
                _this.submit_url = '/order/addOrderModeSubmit';
                _this.submit_data = {
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code,
                    name: '', // 模式名称
                    port: '', // 端口
                    partner_mode: '0', // 合作模式开关
                    is_allow_album_photo: '0', // 是否允许相册选择照片
                    wait_mode: '0', // 自创单模式开关
                    synchronization: '',
                    password: '', // 模式密码
                    check_password: '0', // 是否需要密码
                    kilometer_mode: '0', // 纯公里模式
                    is_sleet: '0', // 恶劣天气
                    scan_appoint_order: '0', // 扫码指定模式
                    kilometer_mode_deduction: '0',
                    kilometer_mode_deduction_type: '0',
                    trip_start_upload_status: '1', // 是否上传照片行程开始前
                    trip_end_upload_status: '1', // 是否上传照片行程结束后
                    restrictive_photo: '', // 上传照片数量限制，默认0就是不限制
                    rule_base: 'orderOnWay', // 计费时间
                    send_plate: '0', // 是否上传车牌号
                    not_income_wallet: '0', // 不进司机余额
                    sign_type: '', // 接单司机类型
                    strategy: 'default', // 司机导航规划策略
                    is_not_dispatch:'0',
                    hourly_package_mode: '0' // 包时模式
                };
            } else {
                // 编辑页面
                _this.submit_url = '/order/editOrderModeSubmit';

                _this.submit_data = {
                    city_code: '',
                    order_mode_code: '',
                    // status: '',
                    name: '', // 模式名称
                    port: '', // 端口
                    sign_type: '', // 接单司机类型
                    trip_start_upload_status: '1', // 是否上传照片(行程开始前)
                    trip_end_upload_status: '1', // 是否上传照片行程结束后
                    restrictive_photo: '', // 上传照片数量限制，默认0就是不限制
                    strategy: 'default', // 司机导航规划策略
                    rule_base: 'orderOnWay', //计费时间
                    scan_appoint_order: '0', // 扫码指定模式
                    send_plate: '0', // 是否上传车牌号
                    is_allow_album_photo: '0', // 是否允许相册选择照片
                    is_sleet: '0', // 恶劣天气加价
                    kilometer_mode: '0', // 纯公里模式
                    not_income_wallet: '0', // 不进司机余额
                    partner_mode: '0', // 合作模式开关
                    wait_mode: '0', // 创单模式开关
                    check_password: '0', // 是否需要密码开关
                    password: '', // 模式密码
                    synchronization: '',
                    kilometer_mode_deduction: '0',
                    kilometer_mode_deduction_type: '0', // 模式扣款金额（扣司机余额）
                    status: '0',
                    is_not_dispatch:'0',
                    hourly_package_mode: '0' // 包时模式
                };
                _this.submit_data.order_mode_code = _this.data;
                _this.value_city_code = _this.drivingModel_select.city;
                _this.getOrderModeDetails(); // 获取模式详情
            }

            _this.modeName = _this.name;

            // 如果是三方模式，合作模式开关状态为关_this.submit_data.partner_mode==0，创单模式开关为关_this.submit_data.wait_mode==0，是否需要密码开关为开_this.submit_data.check_password==1,模式密码为填写的值_this.submit_data.password
            if (_this.modeName == '普通') {
                _this.submit_data.partner_mode = '0'; // 合作模式开关状态为关
                _this.submit_data.wait_mode = '0'; // 创单模式开关为关
                _this.submit_data.check_password = '0'; // 是否需要密码开关为关
                _this.submit_data.password = ''; // 模式密码为空
            } else if (_this.modeName == '创单') {
                _this.submit_data.partner_mode = '0'; // 合作模式开关状态为关
                _this.submit_data.wait_mode = '1'; // 创单模式开关为开

                _this.submit_data.check_password = '0'; // 是否需要密码开关为关
                _this.submit_data.password = ''; // 模式密码为空

                _this.value_port = 'driver'; // 端口默认为司机
                _this.submit_data.port = 'driver'; // 端口默认为司机
            } else if (_this.modeName == '合作') {
                _this.submit_data.partner_mode = '1'; // 合作模式开关状态为开
                _this.submit_data.wait_mode = '0'; // 创单模式开关为关
                _this.submit_data.check_password = '1'; // 是否需要密码开关为开
                _this.submit_data.password = ''; // 模式密码为空
            } else if (_this.modeName == '三方') {
                // 三方
                _this.submit_data.partner_mode = '0'; // 合作模式开关状态为关
                _this.submit_data.wait_mode = '0'; // 创单模式开关为关
                _this.submit_data.check_password = '0'; // 是否需要密码开关为关
                _this.submit_data.password = ''; // 模式密码为填写值

                // _this.password_btn = false; // 是否需要密码开关为关

                _this.value_port = 'openApi'; // 端口默认为三方
                _this.submit_data.port = 'openApi';
            } else if (_this.modeName == '包时') {

                _this.submit_data.hourly_package_mode = '1'; // 包时模式开关状态为开
            }

            // 获取模式规则 一口价需要在此接口加东西否则会导致一口价开关无法点击
            _this
                .$post('/order/getruleMode')
                .then((res) => {
                    _this.obtain_data = res.data;
                })
                .catch((err) => {});
            // 获取包时模式列表
            _this
                .$post('/order/getHourlyPackage',{},{},'normal')
                .then((res) => {
                    _this.modeOptions = res.data;
                })
                .catch((err) => {});
        }
    },
    data() {
        return {
            modeOptions: [],
            loading: true,
            show: false,
            submit_url: '',
            modeName: '',
            init_time: '',
            // 下拉选择端口
            value_port: '',
            // 下拉搜索城市
            value_city_code: '',

            sign_type: [], // 司机类型是多选，所以绑定的是数组
            options_city_code: [],
            //获取到的数据
            obtain_data: [],
            // json格式数据
            spare_data: [

            ],

            city_options_data: {
                page: 1,
                limit: 50,
                name: ''
            },

            // 表单数据
            submit_data: {},
            submit_rules: {
                city_code: {
                    placeholder: '城市编码',
                    rules: {
                        required: true,
                        message: '城市编码错误',
                        regulation: 'special',
                        rulesData: 'city_code'
                    }
                },
                name: {
                    placeholder: '请输入模式名称',
                    rules: {
                        required: true,
                        message: '模式名称错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                port: {
                    placeholder: '端口',
                    rules: {
                        required: false,
                        message: '端口错误',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                synchronization: {
                    placeholder: '收费综合指数',
                    rules: {
                        required: true,
                        message: '收费综合指数错误',
                        regulation: 'synthesize',
                        rulesData: ''
                    }
                },
                kilometer_mode_deduction_type: {
                    placeholder: '模式扣款金额（扣司机余额）',
                    rules: {
                        required: true,
                        message: '模式扣款金额（扣司机余额）为不小于0的数字',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                kilometer_mode_deduction_type1: {
                    placeholder: '模式扣款金额（扣司机余额）',
                    rules: {
                        required: true,
                        message: '模式扣款金额（扣司机余额）为不小于0的整数',
                        regulation: 'between',
                        rulesData: [0, 9999]
                    }
                },
                password: {
                    placeholder: '模式密码',
                    rules: {
                        required: false,
                        message: '模式密码最多为10位',
                        regulation: 'elt_str',
                        rulesData: 10
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        badWeatherInput() {
            for (var i = 0; i < _this.spare_data.length; i++) {
                if (_this.spare_data[i].bad_weather_amount == '') {
                    _this.spare_data[i].bad_weather_amount = 0;
                }
                if (_this.spare_data[i].bad_weather_rate == '') {
                    _this.spare_data[i].bad_weather_rate = 0;
                }
            }
        },
        // 恶劣天气change
        badweatcherChange(e) {
            //如果开关是开的，恶劣天气v-model绑定值默认为0，如果详情接口返回值，开关该按钮则原值保留
            if (e == '1') {
                _this.badWeatherInput();
                // 如果是恶劣天气开关打开，动态添加数据，这样能保证表格样式美观
                if (!_this.obtain_data.hasOwnProperty('bad_weather_amount')) {
                    _this.obtain_data.bad_weather_amount = {
                        cllocation: ['>=0', 0],
                        name: '恶劣天气加价(元)',
                        type: 'float'
                    };
                    _this.obtain_data.bad_weather_rate = {
                        cllocation: ['>=0', 0],
                        name: '恶劣天气加价(%)',
                        type: 'float'
                    };
                }
            } else {
                // 如果打开恶劣天气后关闭，删除动态添加的字段
                // hasOwnProperty 是js一个内置方法，用于检查对象是否具有指定名称的属性
                // 这样操作在编辑页面有个问题就是，进入编辑页面后，如果本来有恶劣天气的值，开关是打开的，我关闭了一下，就会把值删除了
                if (_this.obtain_data.hasOwnProperty('bad_weather_amount')) {
                    delete _this.obtain_data['bad_weather_amount'];
                    delete _this.obtain_data['bad_weather_rate'];
                }
            }
        },

        // 详情
        getOrderModeDetails() {
            _this
                .$post('/order/getOrderModeDetails', {
                    order_mode_code: _this.data,
                    city_code: JSON.parse(localStorage.getItem('login')).city.city_code
                })
                .then((res) => {
                    _this.loading = false;

                    _this.submit_data.city_code = res.data.city.city_code;
                    _this.submit_data.name = res.data.name; // 模式名称

                    _this.submit_data.kilometer_mode_deduction_type = res.data.kilometer_mode_deduction_type.val; // 模式扣款金额（扣司机余额）
                    _this.submit_data.scan_appoint_order = res.data.scan_appoint_order; // 扫码指定模式

                    _this.submit_data.check_password = res.data.check_password.val; //是否需要密码开关

                    _this.submit_data.trip_start_upload_status = res.data.trip_start_upload_status; // 是否上传照片(行程开始前)

                    _this.submit_data.trip_end_upload_status = res.data.trip_end_upload_status; // 是否上传照片(行程结束后)


                    _this.submit_data.is_not_dispatch = res.data.is_not_dispatch.val;

                    if (res.data.restrictive_photo == '0') {
                        // 上传照片数量限制
                        _this.submit_data.restrictive_photo = '不限';
                    } else {
                        _this.submit_data.restrictive_photo = res.data.restrictive_photo;
                    }
                    _this.submit_data.is_sleet = res.data.is_sleet.val; // 恶劣天气加价
                    if (res.data.is_sleet.val == '1') {
                        // 如果恶劣天气开关是开的，需要往spare_data里面追加恶劣天气数据
                        if (!_this.obtain_data.hasOwnProperty('bad_weather_amount')) {
                            _this.obtain_data.bad_weather_amount = {
                                cllocation: ['>=0', 0],
                                name: '恶劣天气加价(元)',
                                type: 'float'
                            };
                            _this.obtain_data.bad_weather_rate = {
                                cllocation: ['>=0', 0],
                                name: '恶劣天气加价(%)',
                                type: 'float'
                            };
                        }
                    }

                    _this.spare_data = res.data.synchronization;

                    _this.submit_data.wait_mode = res.data.wait_mode.val; // 创单模式开关

                    _this.submit_data.status = res.data.status.val;

                    _this.submit_data.send_plate = res.data.send_plate.val; // 是否上传车牌号
                    _this.submit_data.not_income_wallet = res.data.not_income_wallet.val; // 不进司机余额
                    _this.submit_data.rule_base = res.data.rule_base; //计费时间
                    _this.submit_data.strategy = res.data.strategy; // 司机导航规划策略

                    _this.submit_data.partner_mode = res.data.partner_mode.val; // 合作模式开关

                    if (res.data.sign_type) {
                        _this.submit_data.sign_type = JSON.parse(res.data.sign_type); // 接单司机类型
                        _this.sign_type = JSON.parse(res.data.sign_type);
                    }

                    // console.log(res.data.partner_mode.val,'======================');
                    _this.submit_data.kilometer_mode_deduction = res.data.kilometer_mode_deduction;

                    _this.init_time = res.data.synchronization[res.data.synchronization.length - 1].time_end;

                    _this.value_port = res.data.port.alias; // 端口
                    // console.log(_this.value_port);

                    _this.submit_data.is_allow_album_photo = res.data.is_allow_album_photo.val; // 是否允许相册选择照片

                    _this.submit_data.kilometer_mode = res.data.kilometer_mode.val; //纯公里模式
                })
                .catch((err) => {});
        },

        selectConfig() {
            _this.submit_data.kilometer_mode_deduction = '';
        },

        // 删除按钮
        delData(index) {
            // 删除数组中对应index的数据
            // console.log(index, 'index');
            _this.spare_data.splice(index, 1);
        },

        // 提交按钮
        drivingModelOnSubmit() {

            if (_this.submit_data.name == '') {
                this.$message.error('请填写模式名称');
                return;
            }

            if (_this.submit_data.restrictive_photo == '不限') {
                _this.submit_data.restrictive_photo = '0';
            }

            var reg = /^-?\d+$/;
            if (!reg.test(_this.submit_data.restrictive_photo)) {
                _this.$message.error('上传照片数量限制应为整数');
                return;
            }
            if (_this.spare_data.length == 0) {
                this.$message.error('请填写计费规则');
                return;
            }

            _this.submit_data.sign_type = JSON.stringify(_this.sign_type);
            // if (_this.submit_data.kilometer_mode_deduction_type == 2) {
            //     // 模式扣款金额为按比例

            //     var regPos = /^[1-9]+[0-9]*$/; // 验证正整数正则表达式

            //     if (!regPos.test(_this.submit_data.kilometer_mode_deduction)) {
            //         _this.$message.error('模式扣款金额百分比应为正整数');
            //         return;
            //     }
            // }
            // 判断第一个开始时间和最后一个结束时间是否一致
            if (_this.spare_data[0].time_start != _this.spare_data[_this.spare_data.length - 1].time_end) {
                _this.$message.error('时间未形成闭环');

                return;
            }

            for (let i = 1; i < _this.spare_data.length; i++) {
                // 判断开始时间和上一个结束时间是否一致
                if (_this.spare_data[i].time_start != _this.spare_data[i - 1].time_end) {
                    _this.$message.error('时间填写有误，必须包含一天所有时间段');
                    return;
                }
            }

            // 验证包时模式的 hourly_package_config 不能为空
            if (_this.modeName === '包时') {
                for (let index = 0; index < _this.spare_data.length; index++) {
                    if (!_this.spare_data[index].hourly_package_config ||
                        !Array.isArray(_this.spare_data[index].hourly_package_config) ||
                        _this.spare_data[index].hourly_package_config.length === 0) {
                        _this.$message.error(`第${index + 1}个时间段的包时配置不能为空`);
                        return;
                    }

                    for (let configIndex = 0; configIndex < _this.spare_data[index].hourly_package_config.length; configIndex++) {
                        const config = _this.spare_data[index].hourly_package_config[configIndex];
                        if (!config.hourly_package_time || config.hourly_package_time === '') {
                            _this.$message.error(`第${index + 1}个时间段的第${configIndex + 1}个包时配置的分钟数不能为空`);
                            return;
                        }
                        if (!config.hourly_package_price && config.hourly_package_price !== '0') {
                            _this.$message.error(`第${index + 1}个时间段的第${configIndex + 1}个包时配置的价格不能为空`);
                            return;
                        }
                    }
                }
            }

            _this.badWeatherInput();
            // ?干嘛用的
            // _this.submit_rules.synchronization.rulesData = _this.obtain_data;

            // for (let index = 0; index < _this.spare_data.length; index++) {

            //   delete _this.spare_data[index].out_free_time_mode;

            // }
            for (let index = 0; index < _this.spare_data.length; index++) {
                delete _this.spare_data[index].hourly_package_mode;
                if (_this.modeName === '包时') {
                    _this.spare_data[index].short_distance_mode = "0";
                    _this.spare_data[index].two_way_charge = "0";
                }
            }
            console.log(_this.spare_data);
            // 将json格式数据转换成字符串格式赋值给要提交的对象
            _this.submit_data.synchronization = JSON.stringify(_this.spare_data);

            // console.log(_this.spare_data);
            // console.log(_this.submit_data.partner_mode, '_this.submit_data.partner_mode');
            // console.log(_this.submit_data.wait_mode, '_this.submit_data.wait_mode');
            // console.log(_this.submit_data.check_password, '_this.submit_data.check_password');
            // console.log(_this.submit_data.password, '_this.submit_data.password');

            _this
                .$post(
                    _this.submit_url,
                    _this.submit_data
                    // _this.submit_rules
                )
                .then((res) => {
                    _this.$message.success(res.msg);
                    // 向父组件通讯刷新表格内容
                    _this.$emit('onSubmit');
                    // 关闭对话框
                    _this.closeDialog();
                })
                .catch((err) => {});
        },
        // 为组件嵌套太深，导致无法组件无法刷新   使用@input事件，在输入时进行强制刷新
        onInput() {
            _this.$forceUpdate();
        },
        // 阶梯计费添加按钮
        addKiloStep(index) {
            _this.spare_data[index].kilo_step.push({
                kilo_step_kilometer: '',
                kilo_step_kiloprice: ''
            });
            _this.$forceUpdate();
        },
        // 阶梯计费删除按钮
        subKiloStep(index) {
            _this.spare_data[index].kilo_step.pop();
            _this.$forceUpdate();
        },
        kiloChange(index) {
            // 如果选择公里模式，把时间模式输入框清空
            if (_this.spare_data[index].kilometer_time_select == '1') {
                _this.spare_data[index].kilo_time = [];
            }

            // 如果选择时间模式，把公里模式输入框清空
            if (_this.spare_data[index].kilometer_time_select == '2') {
                _this.spare_data[index].kilo = [];
            }
        },
        // 添加按钮 一口价
        addKilo(index) {
            // 选择一口价以后，如果一口价（公里/时间选择）选项未进行选择，则提示用户选择
            if (_this.spare_data[index].kilometer_time_select == '') {
                this.$message.error('请选择一口价（公里/时间选择）！');
                return;
            }
            // console.log(_this.spare_data, '_this.spare_data==');

            if (_this.spare_data[index].kilo == '') {
                _this.spare_data[index].kilo = [];
            }
            if (_this.spare_data[index].kilo_time == '') {
                _this.spare_data[index].kilo_time = [];
            }

            // if (!Array.isArray(_this.spare_data[index].kilo)) {
            //     _this.spare_data[index].kilo = [];
            // }
            // if (!Array.isArray(_this.spare_data[index].kilo_time)) {
            //     _this.spare_data[index].kilo_time = [];
            // }

            if (_this.spare_data[index].kilometer_time_select == '1') {
                // 如果 一口价（公里/时间选择） 是公里模式;  kilo代表 一口价公里模式收费详情 接口返回的是一个对象
                _this.spare_data[index].kilo.push({
                    kilometer: '',
                    kiloprice: ''
                });
            } else if (_this.spare_data[index].kilometer_time_select == '2') {
                // 检查属性 'kilo_time' 是否存在于 _this.spare_data[index] 中
                if ('kilo_time' in _this.spare_data[index]) {
                    // '属性 "kilo_time" 存在于 _this.spare_data[index] 中';
                    // kilo_time代表一口价时间模式收费详情
                    _this.spare_data[index].kilo_time.push({
                        kilotime: '',
                        kilotimeprice: ''
                    });
                } else {
                    // 属性 "kilo_time" 不存在于 _this.spare_data[index] 中';
                    // 如果 'kilo_time' 属性不存在，创建一个空数组
                    _this.spare_data[index].kilo_time = [];
                    _this.spare_data[index].kilo_time.push({
                        kilotime: '',
                        kilotimeprice: ''
                    });
                }
                // kilo_time代表一口价时间模式收费详情
                // _this.spare_data[index].kilo_time.push({
                //     kilotime: '',
                //     kilotimeprice: ''
                // });
            }
            // 是 ‌Vue.js 中的一个方法，用于强制组件重新渲染，即使没有响应式数据发生变化。
            // ‌通常情况下，Vue.js 会自动跟踪数据的变化并进行重新渲染，但有时候您可能需要手动触发重新渲染，这时可以使用 $forceUpdate() 方法。‌
            // 使用场景 当 Vue 的响应式系统未能自动检测到数据变化时。当需要强制组件重新渲染，而不想等待 Vue 的响应式系统自动处理时
            _this.$forceUpdate();
        },

        // 删除按钮 一口价
        subKilo(index) {
            if (_this.spare_data[index].kilometer_time_select == '1') {
                _this.spare_data[index].kilo.pop();
            } else if (_this.spare_data[index].kilometer_time_select == '2') {
                _this.spare_data[index].kilo_time.pop();
            }
            _this.$forceUpdate();
        },

        // 包时添加按钮
        addHourlyPackage(index) {
            // 确保 hourly_package_config 是数组
            if (!Array.isArray(_this.spare_data[index].hourly_package_config)) {
                _this.spare_data[index].hourly_package_config = [];
            }
            _this.spare_data[index].hourly_package_config.push({
                hourly_package_price: '',
                hourly_package_time: ''
            });
        },
        // 包时删除按钮
        subHourlyPackage(index) {
            // 确保 hourly_package_config 是数组且有元素
            if (Array.isArray(_this.spare_data[index].hourly_package_config) &&
                _this.spare_data[index].hourly_package_config.length > 0) {
                _this.spare_data[index].hourly_package_config.pop();
            }
        },
        delHourlyPackage(index, index4) {
            _this.spare_data[index].hourly_package_config.splice(index4, 1);
        },
        // 阶梯计费开关change 增值公里
        kiloStepChange(index) {
            _this.spare_data[index].kilo_step = [
                {
                    kilo_step_kilometer: '',
                    kilo_step_kiloprice: ''
                }
            ];
        },
        // 一口价 短途特惠 双向收费 开关方法
        select(index, val) {
            // 当前index下的一口价和特惠短途开关互斥

            if (val == 'kilometer_time_mode') {
                if (_this.spare_data[index].kilometer_time_select == '1') {
                    _this.spare_data[index].kilo = [
                        {
                            kilometer: '',
                            kiloprice: ''
                        }
                    ];
                } else if (_this.spare_data[index].kilometer_time_select == '2') {
                    _this.spare_data[index].kilo_time = [
                        {
                            kilotime: '',
                            kilotimeprice: ''
                        }
                    ];
                }

                // console.log(_this.spare_data[index]);

                if (_this.spare_data[index].kilometer_time_mode == '1') {
                    // 一口价开关打开
                    _this.spare_data[index].short_distance_mode = '0'; // 关闭短途特惠开关
                    // 短途特惠短途起步价，短途起步公里，短途起步时长输入框 绑定值设置为0
                    _this.spare_data[index].short_starting_price = '0';
                    _this.spare_data[index].short_starting_free_kilometre = '0';
                    _this.spare_data[index].short_starting_free_time = '0';
                }

                // console.log(_this.spare_data[index]);
            } else if (val == 'short_distance') {
                // 点击短途特惠开关
                if (_this.spare_data[index].kilometer_time_select == '1') {
                    _this.spare_data[index].kilo = [];
                } else if (_this.spare_data[index].kilometer_time_select == '2') {
                    _this.spare_data[index].kilo_time = [];
                }

                if (_this.spare_data[index].short_distance_mode == '1') {
                    // 如果短途特惠开关开启
                    _this.spare_data[index].kilometer_time_mode = '0'; // 关闭一口价

                    // 在结构里面显示 短途起步价，短途起步公里，短途起步时长输入框
                } else {
                    // 如果短途特惠开关关闭
                    // 短途起步价，短途起步公里，短途起步时长输入框 绑定值设置为0
                    _this.spare_data[index].short_starting_price = '0';
                    _this.spare_data[index].short_starting_free_kilometre = '0';
                    _this.spare_data[index].short_starting_free_time = '0';
                }
            }
        },

        //添加按钮
        addContent() {
            var obj = {};

            // _this.obtain_data = {
            //     time_start:'',
            //     time_end:'',
            //     short_distance_mode:{
            //         name:'短途特惠'
            //     },
            //      kilometer_time_mode:{
            //         name:'一口价'
            //     },
            //      two_way_charge:{
            //         name:'双向收费'
            //     },
            //      kilo_step:{
            //         name:'增值公里'
            //     },
            //     kilometer_time_select:'',
            //     kilo:[
            //         {
            //             kilometer:'',
            //             kiloprice:'',
            //         }
            //     ],
            //     kilo_time:[
            //         {
            //             kilotime:'',
            //             kilotimeprice:'',
            //         }
            //     ],

            // }
            // 遍历获取到的数据，将对象的键存到obj对象中(值为空)
            for (const key in _this.obtain_data) {
                obj[key] = '';
            }

            obj['time_start'] = _this.init_time;
            // 下面代码加上就报错，不知道为啥
            // obj['kilo'] = []; // 上面的for循环里面把obj所有值初始化成空字符串了，addKilo方法的时候需要push所以，需要初始化成数组
            // obj['kilo_time'] = [];
            // obj['bad_weather_amount'] = '0';
            // obj['bad_weather_rate'] = '0';
            // 初始化 hourly_package_config
            obj['hourly_package_config'] = [
                {
                    hourly_package_time: '30',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '60',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '120',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '180',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '240',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '300',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '360',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '480',
                    hourly_package_price: '',
                },
                {
                    hourly_package_time: '720',
                    hourly_package_price: '',
                },
            ];

            // 每点击一次在数组中加入一个对象
            _this.spare_data.push(obj);
        },
        // 有效时段时间选择器
        timeChange(val, keyData) {
            // console.log(val);
            if (keyData == 'time_end') {
                _this.init_time = val;
            }
        },

        // 关闭方法
        closeDialog() {
            _this.loading = true;

            _this.show = false;
            _this.submit_url = '';
            _this.modeName = '';
            _this.init_time = '';
            // 下拉选择端口
            _this.value_port = '';
            // 下拉搜索城市
            _this.value_city_code = '';

            _this.sign_type = []; // 司机类型是多选，所以绑定的是数组
            _this.options_city_code = [];

            //获取到的数据
            _this.obtain_data = [];

            // json格式数据
            _this.spare_data = [];

            _this.city_options_data = {
                page: 1,
                limit: 50,
                name: ''
            };
            // 表单数据
            _this.submit_data = {};
        },

        // 选择端口
        portChange(val) {
            _this.submit_data.port = val;
        }
    }
};
</script>
<style>
.order-model-wrap .el-radio input[aria-hidden='true'] {
    display: none !important;
}

.order-model-wrap .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
}
</style>

<style scoped>
.mode-title {
    padding: 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eee;
}
.mode-title-package {
    padding: 20px;
    border-bottom: 1px solid #eee;
}
.mode-wrap {
    height: 76vh;
    overflow-y: auto;
    padding-right: 8px;
    color: #606266;
}

.btn-plus {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px 20px 10px;
}

.btn-plus > el-button {
    width: 50px;
    height: 40px;
}

.form-box {
    width: 100%;
    height: calc(100vh - 157.2px);
    overflow-y: auto;
    margin-top: 20px;
    padding: 0 8px 8px 8px;
}

.box-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin-bottom: 10px;
}

.box-time {
    display: flex;
    justify-content: space-around;
    padding: 0 20px;
    box-sizing: border-box;
    margin: 20px 0;
}

.mode-config-father {
    display: flex;
    flex-wrap: wrap;
    margin: 0 auto;
    padding-left: 44px;
}

.mode-config {
    width: 30%;
    margin-top: 10px;
}
.common-style {
    display: flex;
    padding-left: 24px;
}

.time-effective {
    align-items: center;
}
.mode-switch {
    border-bottom: 1px solid #eee;
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
}

.new-mode-father {
    display: flex;
    margin-top: 10px;
    height: 220px;
    border-top: 1px solid #ccc;
}

.new-mode-left {
    border-right: 1px solid #ccc;
    width: 306px !important;

    /* width: 33%; */
    padding: 10px;
}

.new-mode-right {
    width: 650px !important;

    /* width: 70%; */

    display: flex;
}

.new-mode-right-child {
    width: 50% !important;
}

.new-mode-right-child-left-top {
    border-bottom: 1px solid #ccc;
    height: 50%;
    padding: 10px 10px 0 10px;
}

.new-mode-right-child-left-bottom {
    height: 60%;
    padding: 6px 10px 0 10px;
}

.mode-short-kilo {
    display: flex;
    padding-left: 10px;
}

.mode-short-kilo-left {
    width: 294px !important;
    /* width: 32%; */
    /* border-right: 1px solid #ccc; */
    padding: 10px 10px 0 0;
}

.hour-mode-short-kilo {
    width: 294px;
    padding: 10px 10px 10px 0;
}

.mode-short-kilo-right {
    width: 50%;
    padding: 10px 10px 0 10px;
}

.yi-kou-jia-btn {
    display: flex;
    justify-content: space-around;
}
.tips {
    color: #FF4B4B;
    padding: 10px 15px;
    font-size: 14px;
    margin-top: 10px;
    background: rgba(255, 75, 75, 0.1);
    border-radius: 5px;
}
</style>
<style>
/* 设置input框高度 */
.order-model-wrap .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}
.order-model-wrap .el-input-group {
    height: 40px;
}
/* .price-top .el-input--small .el-input__inner {
    width: 54px;
} */
.order-model-wrap .el-input-group__append,
.el-input-group__prepend {
    padding: 0 10px;
    width: 126px;
}
</style>